import { clampStep15 } from "./durationFormat";
import dayjs from "dayjs";

export function segmentStartMs(seg) {
  const value = seg?.services?.[0]?.serviceStart ?? seg?.start;
  const ms = new Date(value).getTime();
  return Number.isFinite(ms) ? ms : 0;
}

/** Unique key when multiple segments share the same event_id. */
export function segmentDraftKey(seg) {
  return [
    seg?.event_id ?? "",
    seg?.services?.[0]?.service_id ?? "",
    segmentStartMs(seg),
  ].join("|");
}

export function sameSegment(a, b) {
  if (!a || !b) return false;
  return segmentDraftKey(a) === segmentDraftKey(b);
}

/** True when this segment is the last booked block of a multi-step service. */
export function isLastBlockOfMultiStepService(segments, segment) {
  const serviceId = String(segment?.services?.[0]?.service_id ?? "");
  if (!serviceId || serviceId === "undefined") return false;
  const parts = [...(segments || [])]
    .filter((s) => String(s?.services?.[0]?.service_id) === serviceId)
    .sort((a, b) => segmentStartMs(a) - segmentStartMs(b));
  if (parts.length < 2) return false;
  return sameSegment(parts[parts.length - 1], segment);
}

export function segmentMinutesFromEvent(seg, allowZero = false) {
  const s = seg?.services?.[0]?.serviceStart ?? seg?.start;
  const e = seg?.services?.[0]?.serviceEnd ?? seg?.end;
  const raw = dayjs(e).diff(dayjs(s), "minute");
  return clampStep15(raw, allowZero ? 0 : 15);
}

export function buildSegmentDurationOverrides(
  mergedSegments,
  uniqueServices,
  draftByKey
) {
  const sorted = [...mergedSegments].sort(
    (a, b) => segmentStartMs(a) - segmentStartMs(b)
  );
  const out = [];
  for (const us of uniqueServices) {
    const parts = sorted
      .filter(
        (seg) =>
          String(seg?.services?.[0]?.service_id) === String(us.service_id)
      )
      .sort((a, b) => segmentStartMs(a) - segmentStartMs(b));
    parts.forEach((p, i) => {
      const allowZero = parts.length > 1 && i === parts.length - 1;
      const key = segmentDraftKey(p);
      const v =
        draftByKey[key] != null
          ? draftByKey[key]
          : segmentMinutesFromEvent(p, allowZero);
      out.push(clampStep15(v, allowZero ? 0 : 15));
    });
  }
  return out;
}
